export function InputGenericTransform<T>(value: any): T {
	return value;
}

export function InputNumberTransform(value: any): number {
	return InputGenericTransform<number>(value);
}

export function InputBooleanTransform(value: any): boolean {
	return InputGenericTransform<boolean>(value !== false);
}

export function InputStringTransform(value: any): string {
	return InputGenericTransform<string>(value);
}

export function InputArrayTransform(value: any): any[] {
	return Array.isArray(value) ? value : [];
}

export function InputObjectTransform(value: any): any {
	return typeof value === 'object' ? value : {};
}

export function InputDateTransform(value: any): Date {
	return new Date(value);
}
